import React from 'react';

const About = () => {
    return (
        <div className="about" id="about">
            <h1 className="about_hello">¡Hola!</h1>
            <p className="about_name" >Me llamo Itziar y soy programadora frontend en Madrid.</p>
            <div id="projects"></div>
        </div>
    )
}

export default About;